import { api } from '../api';

export const urlTestRun = 'tests/testRuns';

export interface S3FileRequest {
    s3Dir: string;
}

export interface S3FileResponse {
    content: unknown;
}

export const testRunApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getS3File: builder.query<S3FileResponse, S3FileRequest>({
      query: ({ s3Dir }) => ({
        url: `${urlTestRun}/s3Dir`,
        method: 'GET',
        params: { directory: s3Dir }
      })
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetS3FileQuery,
} = testRunApi;